enum Labels {
  // General labels
  SELECTED_DATE = 'SELECTED_DATE',
  SELECT_DATE = 'SELECT_DATE',
  LISTEN = 'LABEL_LISTEN',
  CURRENTLY_AT = 'CURRENTLY_AT',
  ATTENTION_REQUIRED_AT = 'ATTENTION_REQUIRED_AT',
  LOG_OUT = 'LOG_OUT',
  NEXT_STEP = 'NEXT_STEP',
  NEXT = 'NEXT',
  BACK = 'BACK',
  PROCEED_TO_SIGNING = 'PROCEED_TO_SIGNING',
  PROCEED_TO_SIGNING_WEFOX = 'PROCEED_TO_SIGNING_WEFOX',
  EDIT_HEALTH_DECLARATION = 'EDIT_HEALTH_DECLARATION',
  VIEW_HEALTH_DECLARATION = 'VIEW_HEALTH_DECLARATION',
  VIEW_MEDICAL_REASON = 'VIEW_MEDICAL_REASON',
  PLEASE_WAIT = 'PLEASE_WAIT',
  MR = 'MR',
  MS = 'MS',
  INSTRUCTIONS_WELCOME_HEADER = 'INSTRUCTIONS_WELCOME_HEADER',
  INSTRUCTIONS_WELCOME_TEXT = 'INSTRUCTIONS_WELCOME_TEXT',
  INSTRUCTIONS_SIGN_ONLINE_TEXT = 'INSTRUCTIONS_SIGN_ONLINE_TEXT',
  INSTRUCTIONS_AFTER_SIGNING_TEXT = 'INSTRUCTIONS_AFTER_SIGNING_TEXT',
  INSTRUCTIONS_AFTER_SIGNING_SUPPLEMENTAL = 'INSTRUCTIONS_AFTER_SIGNING_SUPPLEMENTAL',
  INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1 = 'INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1',
  INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1_EXPLANATION = 'INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_1_EXPLANATION',
  INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2 = 'INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2',
  INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2_EXPLANATION = 'INSTRUCTIONS_AFTER_SIGNING_LIST_ITEM_2_EXPLANATION',
  INSTRUCTIONS_IMPORTANT_REMARKS_TEXT = 'INSTRUCTIONS_IMPORTANT_REMARKS_TEXT',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1 = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1_EXPLANATION = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_1_EXPLANATION',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2 = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2_EXPLANATION = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_2_EXPLANATION',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3 = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3',
  INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3_EXPLANATION = 'INSTRUCTIONS_IMPORTANT_REMARKS_LIST_ITEM_3_EXPLANATION',
  INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_1 = 'INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_1',
  INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_2 = 'INSTRUCTIONS_IMPORTANT_REMARKS_SUB_LIST_ITEM_2',
  INSTRUCTIONS_DISCLAIMER_TEXT = 'INSTRUCTIONS_DISCLAIMER_TEXT',
  INSTRUCTIONS_SIGN_ONLINE_HEADER = 'INSTRUCTIONS_SIGN_ONLINE_HEADER',
  INSTRUCTIONS_AFTER_SIGNING_HEADER = 'INSTRUCTIONS_AFTER_SIGNING_HEADER',
  INSTRUCTIONS_IMPORTANT_REMARKS_HEADER = 'INSTRUCTIONS_IMPORTANT_REMARKS_HEADER',
  INSTRUCTIONS_DISCLAIMER_HEADER = 'INSTRUCTIONS_DISCLAIMER_HEADER',
  INSTRUCTIONS_CHECKBOX_TITLE = 'INSTRUCTIONS_CHECKBOX_TITLE',
  INSTRUCTIONS_CHECKBOX_TITLE_MAGNUM = 'INSTRUCTIONS_CHECKBOX_TITLE_MAGNUM',
  INSTRUCTIONS_CHECKBOX_TITLE_WEFOX = 'INSTRUCTIONS_CHECKBOX_TITLE_WEFOX',
  INSTRUCTIONS_CHECKBOX_TITLE_DHMR = 'INSTRUCTIONS_CHECKBOX_TITLE_DHMR',
  COMPLETE_HEADER = 'COMPLETE_HEADER',
  COMPLETE_WEFOX_HEADER = 'COMPLETE_WEFOX_HEADER',
  COMPLETE_DHMR_HEADER = 'COMPLETE_DHMR_HEADER',
  COMPLETE_CHECKBOX_TITLE1 = 'COMPLETE_CHECKBOX_TITLE1',
  COMPLETE_CHECKBOX_TITLE2 = 'COMPLETE_CHECKBOX_TITLE2',
  COMPLETE_CHECKBOX_TITLE3 = 'COMPLETE_CHECKBOX_TITLE3',
  COMPLETE_WEFOX_CHECKBOX_TITLE1 = 'COMPLETE_WEFOX_CHECKBOX_TITLE1',
  COMPLETE_WEFOX_CHECKBOX_TITLE2 = 'COMPLETE_WEFOX_CHECKBOX_TITLE2',
  COMPLETE_WEFOX_CHECKBOX_TITLE3 = 'COMPLETE_WEFOX_CHECKBOX_TITLE3',
  COMPLETE_WEFOX_CHECKBOX_TITLE4 = 'COMPLETE_WEFOX_CHECKBOX_TITLE4',
  COMPLETE_WEFOX_CHECKBOX_TITLE5 = 'COMPLETE_WEFOX_CHECKBOX_TITLE5',
  COMPLETE_WEFOX_CHECKBOX_TITLE6 = 'COMPLETE_WEFOX_CHECKBOX_TITLE6',
  COMPLETE_P1 = 'COMPLETE_P1',
  COMPLETE_WEFOX_P1 = 'COMPLETE_WEFOX_P1',
  COMPLETE_DHMR_P1 = 'COMPLETE_DHMR_P1',
  COMPLETE_WEFOX_P2 = 'COMPLETE_WEFOX_P2',
  COMPLETE_P3 = 'COMPLETE_P3',
  COMPLETE_WEFOX_P3 = 'COMPLETE_WEFOX_P3',
  COMPLETE_P4 = 'COMPLETE_P4',
  COMPLETE_WEFOX_P4 = 'COMPLETE_WEFOX_P4',
  COMPLETE_WEFOX_P5 = 'COMPLETE_WEFOX_P5',
  COMPLETE_DHMR_P5 = 'COMPLETE_DHMR_P5',
  COMPLETE_WEFOX_P6 = 'COMPLETE_WEFOX_P6',
  COMPLETE_P7 = 'COMPLETE_P7',
  COMPLETE_DHMR_LI1 = 'COMPLETE_DHMR_LI1',
  COMPLETE_DHMR_LI2 = 'COMPLETE_DHMR_LI2',
  COMPLETE_DHMR_LI3 = 'COMPLETE_DHMR_LI3',
  ERROR_HEADER = 'ERROR_HEADER',
  ERROR_P1 = 'ERROR_P1',
  ERROR_CONTACTS_HEADER = 'ERROR_CONTACTS_HEADER',
  NON_AUTHORIZED_UNIQUE_URL = 'NON_AUTHORIZED_UNIQUE_URL',
  NON_AUTHORIZED_INVALID_QS1 = 'NON_AUTHORIZED_INVALID_QS1',
  NON_AUTHORIZED_INVALID_QS2 = 'NON_AUTHORIZED_INVALID_QS2',
  NON_AUTHORIZED_LOGOUT_TITLE = 'NON_AUTHORIZED_LOGOUT_TITLE',
  NON_AUTHORIZED_LOGOUT_RETURN_LINK = 'NON_AUTHORIZED_LOGOUT_RETURN_LINK',
  NON_AUTHORIZED_KEYCLOAK_LOG_OUT = 'NON_AUTHORIZED_KEYCLOAK_LOG_OUT',
  PERSONAL_DETAILS_HEADER1 = 'PERSONAL_DETAILS_HEADER1',
  PERSONAL_DETAILS_HEADER2 = 'PERSONAL_DETAILS_HEADER2',
  PERSONAL_DETAILS_HEADER3 = 'PERSONAL_DETAILS_HEADER3',
  PERSONAL_DETAILS_P1 = 'PERSONAL_DETAILS_P1',
  PERSONAL_DETAILS_P2 = 'PERSONAL_DETAILS_P2',
  PERSONAL_DETAILS_INITIALS = 'PERSONAL_DETAILS_INITIALS',
  PERSONAL_DETAILS_FIRST_NAME = 'PERSONAL_DETAILS_FIRST_NAME',
  PERSONAL_DETAILS_MIDDLE_NAME = 'PERSONAL_DETAILS_MIDDLE_NAME',
  PERSONAL_DETAILS_LAST_NAME = 'PERSONAL_DETAILS_LAST_NAME',
  PERSONAL_DETAILS_GENDER = 'PERSONAL_DETAILS_GENDER',
  PERSONAL_DETAILS_MALE = 'PERSONAL_DETAILS_MALE',
  PERSONAL_DETAILS_FEMALE = 'PERSONAL_DETAILS_FEMALE',
  PERSONAL_DETAILS_BIRTHDATE = 'PERSONAL_DETAILS_BIRTHDATE',
  PERSONAL_DETAILS_NATIONALITY = 'PERSONAL_DETAILS_NATIONALITY',
  PERSONAL_DETAILS_SSN = 'PERSONAL_DETAILS_SSN',
  PERSONAL_DETAILS_PHONE = 'PERSONAL_DETAILS_PHONE',
  PERSONAL_DETAILS_EMAIL = 'PERSONAL_DETAILS_EMAIL',
  PERSONAL_DETAILS_STREET = 'PERSONAL_DETAILS_STREET',
  PERSONAL_DETAILS_RESIDENCE = 'PERSONAL_DETAILS_RESIDENCE',
  PERSONAL_DETAILS_COUNTRY = 'PERSONAL_DETAILS_COUNTRY',
  PERSONAL_DETAILS_YOUR_DOCTOR = 'PERSONAL_DETAILS_YOUR_DOCTOR',
  PERSONAL_DETAILS_INTERNATIONAL_ADDRESS = 'PERSONAL_DETAILS_INTERNATIONAL_ADDRESS',
  PERSONAL_DETAILS_ZIP_CODE_HOUSE_NUMBER = 'PERSONAL_DETAILS_ZIP_CODE_HOUSE_NUMBER',
  PERSONAL_DETAILS_HOUSE_NUMBER = 'PERSONAL_DETAILS_HOUSE_NUMBER',
  PERSONAL_DETAILS_HOUSE_LETTER = 'PERSONAL_DETAILS_HOUSE_LETTER',
  PERSONAL_DETAILS_ZIP_CODE_NO_RESULT = 'PERSONAL_DETAILS_ZIP_CODE_NO_RESULT',
  PERSONAL_DETAILS_ZIP_CODE = 'PERSONAL_DETAILS_ZIP_CODE',
  PROGRESS_BAR_STEP = 'PROGRESS_BAR_STEP',
  PROGRESS_BAR_STEP1 = 'PROGRESS_BAR_STEP1',
  PROGRESS_BAR_STEP2 = 'PROGRESS_BAR_STEP2',
  PROGRESS_BAR_STEP3 = 'PROGRESS_BAR_STEP3',
  PROGRESS_BAR_STEP4 = 'PROGRESS_BAR_STEP4',
  PROGRESS_BAR_STEP5 = 'PROGRESS_BAR_STEP5',
  REJECTED_HEADER = 'REJECTED_HEADER',
  REJECTED_P = 'REJECTED_P',
  SIGNED_HEALTH_DEC_HEADER = 'SIGNED_HEALTH_DEC_HEADER',
  SIGNED_HEALTH_DEC_WEFOX_HEADER = 'SIGNED_HEALTH_DEC_WEFOX_HEADER',
  SIGNED_HEALTH_DEC_DHMR_HEADER = 'SIGNED_HEALTH_DEC_DHMR_HEADER',
  SIGNED_HEALTH_DEC_P1 = 'SIGNED_HEALTH_DEC_P1',
  SIGNED_HEALTH_DEC_DHMR_P1 = 'SIGNED_HEALTH_DEC_DHMR_P1',
  SIGNED_HEALTH_DEC_P2 = 'SIGNED_HEALTH_DEC_P2',
  SIGNED_HEALTH_DEC_DHMR_P2 = 'SIGNED_HEALTH_DEC_DHMR_P2',
  SIGNED_HEALTH_DEC_P3 = 'SIGNED_HEALTH_DEC_P3',
  SIGNED_HEALTH_DEC_DHMR_P3 = 'SIGNED_HEALTH_DEC_DHMR_P3',
  SIGNED_HEALTH_DEC_P4 = 'SIGNED_HEALTH_DEC_P4',
  SIGNED_HEALTH_DEC_DHMR_P4 = 'SIGNED_HEALTH_DEC_DHMR_P4',
  SIGNED_HEALTH_DEC_P5 = 'SIGNED_HEALTH_DEC_P5',
  SIGNED_HEALTH_DEC_DHMR_P5 = 'SIGNED_HEALTH_DEC_DHMR_P5',
  SIGNED_HEALTH_DEC_P6 = 'SIGNED_HEALTH_DEC_P6',
  SIGNED_HEALTH_DEC_P7 = 'SIGNED_HEALTH_DEC_P7',
  SIGNED_HEALTH_DEC_DHMR_P7 = 'SIGNED_HEALTH_DEC_DHMR_P7',
  SIGNED_HEALTH_DEC_WEFOX_P7 = 'SIGNED_HEALTH_DEC_WEFOX_P7',
  WAITING_FOR_SIGNING_HEADER = 'WAITING_FOR_SIGNING_HEADER',
  WAITING_FOR_SIGNING_WEFOX_HEADER = 'WAITING_FOR_SIGNING_WEFOX_HEADER',
  WAITING_FOR_SIGNING_P1 = 'WAITING_FOR_SIGNING_P1',
  WAITING_FOR_SIGNING_WEFOX_P1 = 'WAITING_FOR_SIGNING_WEFOX_P1',
  WAITING_FOR_SIGNING_P2 = 'WAITING_FOR_SIGNING_P2',
  WAITING_FOR_SIGNING_WEFOX_P2 = 'WAITING_FOR_SIGNING_WEFOX_P2',
  ERROR_BLOCK_SINGLE_ERROR = 'ERROR_BLOCK_SINGLE_ERROR',
  ERROR_BLOCK_MULTIPLE_ERRORS = 'ERROR_BLOCK_MULTIPLE_ERRORS',
  ERROR_BLOCK_REQUIRED = 'ERROR_BLOCK_REQUIRED',
  ERROR_BLOCK_INVALID_PHONE = 'ERROR_BLOCK_INVALID_PHONE',
  ERROR_BLOCK_INVALID_EMAIL = 'ERROR_BLOCK_INVALID_EMAIL',
  ERROR_BLOCK_INVALID_SSN = 'ERROR_BLOCK_INVALID_SSN',
  ERROR_BLOCK_INVALID_ZIP_CODE = 'ERROR_BLOCK_INVALID_ZIP_CODE',
  ERROR_BLOCK_INTEGER_ABOVE_ZERO = 'ERROR_BLOCK_INTEGER_ABOVE_ZERO',
  ERROR_BLOCK_INTEGER_AT_LEAST_ZERO = 'ERROR_BLOCK_INTEGER_AT_LEAST_ZERO',
  ERROR_BLOCK_AT_LEAST_ONE_SELECTED = 'ERROR_BLOCK_AT_LEAST_ONE_SELECTED',
  ERROR_BLOCK_AT_MOST_ONE_SELECTED = 'ERROR_BLOCK_AT_MOST_ONE_SELECTED',
  ERROR_BLOCK_WRONG_DATE = 'ERROR_BLOCK_WRONG_DATE',
  ERROR_BLOCK_NO_DECIMALS_ALLOWED = 'ERROR_BLOCK_NO_DECIMALS_ALLOWED',
  ERROR_BLOCK_CATEGORY_LOADING_HEADER = 'ERROR_BLOCK_CATEGORY_LOADING_HEADER',
  ERROR_BLOCK_CATEGORY_LOADING_P = 'ERROR_BLOCK_CATEGORY_LOADING_P',
  ERROR_BLOCK_NOT_VALID_VALUE = 'ERROR_BLOCK_NOT_VALID_VALUE',
  ERROR_BLOCK_VALUE_FROM_LIST = 'ERROR_BLOCK_VALUE_FROM_LIST',
  ERROR_REQUIRED = 'ERROR_REQUIRED',
  ERROR_REQUIRED_OCCUPATION_HB = 'ERROR_REQUIRED_OCCUPATION_HB',
  ERROR_INVALID_PHONE = 'ERROR_INVALID_PHONE',
  ERROR_INVALID_EMAIL = 'ERROR_INVALID_EMAIL',
  ERROR_INVALID_SSN = 'ERROR_INVALID_SSN',
  ERROR_INVALID_ZIP_CODE = 'ERROR_INVALID_ZIP_CODE',
  ERROR_HOUSE_NUMBER_IS_NOT_NUMERIC = 'ERROR_HOUSE_NUMBER_IS_NOT_NUMERIC',
  ERROR_INTEGER_ABOVE_ZERO = 'ERROR_INTEGER_ABOVE_ZERO',
  ERROR_INTEGER_AT_LEAST_ZERO = 'ERROR_INTEGER_AT_LEAST_ZERO',
  ERROR_FLOAT_ABOVE_ZERO = 'ERROR_FLOAT_ABOVE_ZERO',
  ERROR_FLOAT_AT_LEAST_ZERO = 'ERROR_FLOAT_AT_LEAST_ZERO',
  ERROR_AT_LEAST_ONE_SELECTED = 'ERROR_AT_LEAST_ONE_SELECTED',
  ERROR_AT_MOST_ONE_SELECTED = 'ERROR_AT_MOST_ONE_SELECTED',
  ERROR_NO_DECIMALS_ALLOWED = 'ERROR_NO_DECIMALS_ALLOWED',
  ERROR_WRONG_DATE = 'ERROR_WRONG_DATE',
  ERROR_WRONG_DATE_STOP_SMOKING_10_YEARS = 'ERROR_WRONG_DATE_STOP_SMOKING_10_YEARS',
  ERROR_BLOCK_WRONG_DATE_STOP_SMOKING_10_YEARS = 'ERROR_BLOCK_WRONG_DATE_STOP_SMOKING_10_YEARS',
  ERROR_VALUE_FROM_LIST = 'ERROR_VALUE_FROM_LIST',
  DATE_PLACEHOLDER = 'DATE_PLACEHOLDER',
  PRODUCT_TYPE_ORV = 'PRODUCT_TYPE_ORV',
  PRODUCT_TYPE_MLB = 'PRODUCT_TYPE_MLB',
  PRODUCT_TYPE_MLBZ = 'PRODUCT_TYPE_MLBZ',
  PRODUCT_TYPE_GG = 'PRODUCT_TYPE_GG',
  PRODUCT_TYPE_NB = 'PRODUCT_TYPE_NB',
  PRODUCT_TYPE_EOP = 'PRODUCT_TYPE_EOP',
  PRODUCT_TYPE_BG = 'PRODUCT_TYPE_BG',
  PRODUCT_TYPE_TIB = 'PRODUCT_TYPE_TIB',
  PRODUCT_TYPE_HB = 'PRODUCT_TYPE_HB',
  PRODUCT_TYPE_AP = 'PRODUCT_TYPE_AP',
  PRODUCT_TYPE_IZ = 'PRODUCT_TYPE_IZ',
  PRODUCT_TYPE_UNKNOWN = 'PRODUCT_TYPE_UNKNOWN',
  MAINTENANCE_HEADER = 'MAINTENANCE_HEADER',
  MAINTENANCE_P1 = 'MAINTENANCE_P1',
  MAINTENANCE_P2 = 'MAINTENANCE_P2',
  MAINTENANCE_P3 = 'MAINTENANCE_P3',
  MAINTENANCE_P4 = 'MAINTENANCE_P4',
  YES = 'YES',
  NO = 'NO',
  UNDERWRITER_TITLE = 'UNDERWRITER_TITLE',
  UNDERWRITER_EXPLANATION = 'UNDERWRITER_EXPLANATION',
  DHMR_QUESTIONNAIRE_TITLE = 'DHMR_QUESTIONNAIRE_TITLE',
  DHMR_QUESTIONNAIRE_EXPLANATION = 'DHMR_QUESTIONNAIRE_EXPLANATION',
  ERROR_NOT_VALID_VALUE = 'ERROR_NOT_VALID_VALUE',
  DOCUMENTS_UPLOAD_QUESTION_LABEL = 'DOCUMENTS_UPLOAD_QUESTION_LABEL',
  DOCUMENTS_UPLOAD_LIST_ITEM_1 = 'DOCUMENTS_UPLOAD_LIST_ITEM_1',
  DOCUMENTS_UPLOAD_LIST_ITEM_2 = 'DOCUMENTS_UPLOAD_LIST_ITEM_2',
  DOCUMENTS_UPLOAD_AT_LEAST_ONE_ERROR_DHMR = 'DOCUMENTS_UPLOAD_AT_LEAST_ONE_ERROR_DHMR',
  DOCUMENTS_UPLOAD_FILES_TOTAL_SIZE = 'DOCUMENTS_UPLOAD_FILES_TOTAL_SIZE',
  FILE_UPLOAD_LABEL1 = 'FILE_UPLOAD_LABEL1',
  FILE_UPLOAD_LABEL2 = 'FILE_UPLOAD_LABEL2',
  FILE_UPLOAD_LABEL3 = 'FILE_UPLOAD_LABEL3',
  FILE_UPLOAD_VALIDATION_LABEL1 = 'FILE_UPLOAD_VALIDATION_LABEL1',
  FILE_UPLOAD_VALIDATION_LABEL2 = 'FILE_UPLOAD_VALIDATION_LABEL2',
  FILE_UPLOAD_VALIDATION_LABEL3 = 'FILE_UPLOAD_VALIDATION_LABEL3',
  HEALTH_DOC_SIZE_ERROR = 'HEALTH_DOC_SIZE_ERROR',
  HEALTH_DOC_EXT_ERROR = 'HEALTH_DOC_EXT_ERROR',
  HEALTH_DOC_DUPLICATION_ERROR = 'HEALTH_DOC_DUPLICATION_ERROR',
  HEALTH_DOC_ERROR = 'HEALTH_DOC_ERROR',
  HEALTH_DOC_REMOVE = 'HEALTH_DOC_REMOVE',
  HEALTH_DOC_DESCRIPTION_PLACEHOLDER = 'HEALTH_DOC_DESCRIPTION_PLACEHOLDER',
  HEALTH_DOC_TH1 = 'HEALTH_DOC_TH1',
  HEALTH_DOC_TH2 = 'HEALTH_DOC_TH2',
  HEALTH_DOC_TH3 = 'HEALTH_DOC_TH3',
  HEALTH_DOC_TH4 = 'HEALTH_DOC_TH4',
  HEALTH_DOC_TH5 = 'HEALTH_DOC_TH5',
  HEALTH_DOC_CONFIRM_UPLOAD = 'HEALTH_DOC_CONFIRM_UPLOAD',
  HEALTH_DOC_UPLOADED = 'HEALTH_DOC_UPLOADED',
  COOKIE_NOTIFICATION_MESSAGE = 'COOKIE_NOTIFICATION_MESSAGE',
  COOKIE_NOTIFICATION_ALLOW = 'COOKIE_NOTIFICATION_ALLOW',
  COOKIE_NOTIFICATION_DENY = 'COOKIE_NOTIFICATION_DENY',
  DIGITAL_HEALTH_DECLARATION = 'DIGITAL_HEALTH_DECLARATION',
  HEALTH_DECLARATION_FILE_NAME = 'HEALTH_DECLARATION_FILE_NAME',
  MEDICAL_REASON_FILE_NAME = 'MEDICAL_REASON_FILE_NAME',
  VALIDATE_INSTRUCTION_ACCEPTED_CHECKBOX = 'VALIDATE_INSTRUCTION_ACCEPTED_CHECKBOX',
  ERROR_INVALID_DATE = 'ERROR_INVALID_DATE',
  COMPLETE_P3_TAF = 'COMPLETE_P3_TAF',
  COMPLETE_P4_1_TAF = 'COMPLETE_P4_1_TAF',
  COMPLETE_CHECKBOX_TITLE4 = 'COMPLETE_CHECKBOX_TITLE4',
  COMPLETE_CHECKBOX_LIST1 = 'COMPLETE_CHECKBOX_LIST1',
  COMPLETE_CHECKBOX_LIST2 = 'COMPLETE_CHECKBOX_LIST2',
  COMPLETE_CHECKBOX_LIST3 = 'COMPLETE_CHECKBOX_LIST3',
  COMPLETE_CHECKBOX_LIST4 = 'COMPLETE_CHECKBOX_LIST4',
  COMPLETE_CHECKBOX_LIST5 = 'COMPLETE_CHECKBOX_LIST5',
  COMPLETE_CHECKBOX_LIST6 = 'COMPLETE_CHECKBOX_LIST6',
  COMPLETE_CHECKBOX_LIST7 = 'COMPLETE_CHECKBOX_LIST7',
}

export default Labels;
